import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { AppConfigService } from '../../../app.config';
import { AlertService, MessageSeverity } from '../../../services/alert.service';
import { AppTranslationService } from '../../../services/app-translation.service';
import { SalesFileService } from '../../services/sales-file.service';
import { PlanStatus } from '../../../plan/enums/plan-status.enum';

@Component({
  selector: 'crm-review-user-target',
  templateUrl: './review-user-target.component.html',
  styleUrls: ['./review-user-target.component.css']
})
export class ReviewUserTargetComponent implements OnInit {

  @Output() closeEvent = new EventEmitter<boolean>();
  @Input() fileId: number;
  @Input() viewOnly: boolean;
  pageSize: number = this.appConfig.settings.pageSize;
  fileData: any;
  columns: any[] = [];

  constructor(private translateService: AppTranslationService, private alertService: AlertService,
    private readonly appConfig: AppConfigService, private salesFileService: SalesFileService) { }

  ngOnInit() {
    this.getFile();
    this.columns = [

      { field: 'month', header: 'Month' },
      { field: 'year', header: 'Year' },
      { field: 'hcoName', header: 'Name' },
      { field: 'productName', header: 'Item Name' },
      { field: 'quantity', header: 'Quantity' },
      { field: 'value', header: 'Value' },
      { field: 'status', header: 'Status' }
    ];
  }


  getFile() {
    this.salesFileService.getUserTargetFileDataById(this.fileId).subscribe(response => {
      let result = response as any[];
      this.fileData = result;
    }, err => {
      console.log(err);
    });
  }

  approve(isApproved) {
    let model = {
      isApproved: isApproved,
      salesFileId: this.fileId,
      userTargets: this.fileData
    }
    this.salesFileService.approveUserTargetFile(model).subscribe(response => {
      if (isApproved)
        this.alertService.showMessage("", this.translateService.getTranslation("plans.approvedSuccessfully"), MessageSeverity.Success);
      else
        this.alertService.showMessage("", this.translateService.getTranslation("plans.rejectedSuccessfully"), MessageSeverity.Success);
      this.closeEvent.emit(true);
    }, err => {
      console.log(err);
    });


  }

  cancel() {
    this.closeEvent.emit(false);
  }

  getStatusName(status: number): string {
    return PlanStatus[status];
  }
}
